/*
 * @Author: your name
 * @Date: 2020-10-21 15:45:04
 * @LastEditTime: 2020-12-18 11:05:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/webSocket/index.js
 */
import MassageHandler from './messageHandle.js';
import { Local } from '@/utils/local.js';
import { Decrypt } from '@/utils/encrypt.js';
const WebsocketCallBackList = {},
      websocketHistory = {},
      websocketErrorList = {},
      websocketCloseList = {},
      websocketOpenList = {};
let startFlag = false;
const moduleType = window.location.hash.split('/')[1];
const webSocketProxy = {
  startWebsocket(connectName, module) {
    webSocketProxy.generateUUID();
    let timestamp = new Date().getTime();
    webSocketProxy[connectName].emit('auth', {
      // 发送授权请求消息
      companyId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).companyId || 0,
      schoolId: Local.get('schoolId') || 0,
      userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId || 0,
      token: webSocketProxy.generateToken(timestamp),
      date: timestamp,
      deviceId: Local.get('deviceId'),
      module: module || 'yunduo'
    });
    this.timerNetty && clearInterval(this.timerNetty);
    this.timerNetty = setInterval(() => {
      // 心跳
      webSocketProxy[connectName].emit('heartBreak');
    }, 10000);
  },

  loginWebsocket(connectName, key, module, userId) {
    let timestamp = new Date().getTime();
    webSocketProxy[connectName].emit(key, {
      // 发送授权请求消息
      companyId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).companyId || 0,
      schoolId: Local.get('schoolId') || 0,
      userId,
      token: webSocketProxy.generateToken(timestamp),
      date: timestamp,
      deviceId: webSocketProxy.generateUUID(),
      module
    });
  },

  install(connectName) {
    // console.warn(connectName, JSON.stringify(MassageHandler[connectName]))
    let websocket = MassageHandler[connectName];
    if (!websocket) return;
    let headerConfig = Object.assign({}, websocket.config.optionList);
    let opConfig = {};
    headerConfig && Object.keys(headerConfig).forEach(v => {
      opConfig[headerConfig[v].resOp] = v;
    });

    websocket.onMessage = async msg => {
      let body, type;
      body = JSON.parse(msg.toString());
      type = body.type;
      let opName = opConfig[type],
          config = headerConfig[opName];
      opName && WebsocketCallBackList[opName] && WebsocketCallBackList[opName].forEach(func => func(body));
    };

    websocket.onOpen = data => {
      // console.log('onOpen', websocketOpenList)
      // webSocketProxy.startWebsocket(connectName);
      Object.keys(websocketOpenList).forEach(v => websocketOpenList[v].forEach(func => func(data)));
    };

    websocket.onClose = data => {
      this.timerNetty && clearInterval(this.timerNetty); // console.log('onClose', 'websocketHistory', websocketCloseList);
      // 执行关闭队列

      Object.keys(websocketCloseList).forEach(v => websocketCloseList[v].forEach(func => func(data)));

      websocket.onOpen = data => {
        webSocketProxy.startWebsocket(connectName);
        Object.keys(websocketOpenList).forEach(v => websocketOpenList[v].forEach(func => func(data)));
        Object.keys(websocketHistory).forEach(v => websocketHistory[v].forEach(vv => webSocketProxy[connectName].emit(v, vv)));
      };
    };

    websocket.onError = data => {
      // console.log('onError', 'websocketErrorList', websocketErrorList);
      this.timerNetty && clearInterval(this.timerNetty); // 执行错误队列

      Object.keys(websocketErrorList).forEach(v => websocketErrorList[v].forEach(func => func(data)));

      websocket.onOpen = data => {
        webSocketProxy.startWebsocket(connectName);
        Object.keys(websocketOpenList).forEach(v => websocketOpenList[v].forEach(func => func(data)));
        Object.keys(websocketHistory).forEach(v => websocketHistory[v].forEach(vv => webSocketProxy[connectName].emit(v, vv)));
      };
    };

    webSocketProxy[connectName] = {};

    webSocketProxy[connectName].emit = (key, data) => {
      headerConfig[key].history && webSocketProxy[connectName].pushWebsocketHistoryArr(key, JSON.parse(JSON.stringify(data)), headerConfig[key].historyFunc);
      let emitData = webSocketProxy.formatWebSocketEmitData(headerConfig, key, data); // data && console.log('sendWebsocket', JSON.stringify(emitData));
      // console.log('sendWebsocketKey', key);

      websocket.send(JSON.stringify(emitData));
    }; // 关闭事件


    webSocketProxy[connectName].close = (key, data) => {
      websocket.close();
    }; // 监听数组


    webSocketProxy[connectName].on = (key, func) => {
      if (!WebsocketCallBackList[key]) {
        WebsocketCallBackList[key] = [];
      }

      WebsocketCallBackList[key].push(func);
    }; // 清空监听数组


    webSocketProxy[connectName].clear = key => {
      WebsocketCallBackList[key] = [];
    }; // 监听历史数据


    webSocketProxy[connectName].pushWebsocketHistoryArr = (key, value, func) => {
      websocketHistory[key] = websocketHistory[key] || [];

      if (func) {
        websocketHistory[key] = func(websocketHistory[key], value);
        return;
      }

      websocketHistory[key].push(value);
    };

    webSocketProxy[connectName].clearWebsocketHistoryArr = key => {
      websocketHistory[key] = [];
    }; // 监听错误


    webSocketProxy.pushErrorList = (key, func) => {
      websocketErrorList[key] = websocketErrorList[key] || [];
      websocketErrorList[key].push(func);
    };

    webSocketProxy.clearWebsocketErrorList = key => {
      websocketErrorList[key] = [];
    }; // 监听关闭


    webSocketProxy.pushCloseList = (key, func) => {
      websocketCloseList[key] = websocketCloseList[key] || [];
      websocketCloseList[key].push(func);
    };

    webSocketProxy.clearWebsocketCloseList = key => {
      websocketCloseList[key] = [];
    }; // 监听开启


    webSocketProxy.pushOpenList = (key, func) => {
      websocketOpenList[key] = websocketOpenList[key] || [];
      websocketOpenList[key].push(func);
    };

    webSocketProxy.clearWebsocketOpenList = key => {
      websocketOpenList[key] = [];
    };

    if (!startFlag) {
      webSocketProxy.startWebsocket(connectName);
      startFlag = true;
    }
  },

  formatWebSocketEmitData(headerConfig, key, data) {
    let obj = Object.assign({}, {
      type: headerConfig[key].resOp
    }, data);
    return obj;
  },

  generateUUID() {
    // 生成UUID, 用于设备码
    let S4 = () => {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    };

    let id = S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();

    if (!Local.get('deviceId')) {
      Local.set('deviceId', id);
    }

    return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
  },

  generateToken(timestamp) {
    // 根据companyId, userId, timestamp, salt 生成token
    let companyId = Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).companyId || 0;
    let userId = Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId || 0;
    let salt = "Yuuxin";
    return hex_md5(encodeURIComponent(String(companyId) + String(userId) + String(timestamp) + salt)).toUpperCase();
  },

  getModule(type) {
    // 获取Module
    let module = '';

    switch (type) {
      case 'home':
        module = 'home';
        break;

      case 'lib':
        module = 'question';
        break;

      default:
        module = 'yunduo';
    }

    return module;
  }

};
export default webSocketProxy;